import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, EDIT, DELETE } from "const"
import { RrsTemplate } from "server/models"
import {
    PRM_RRS_TEMPLATE,
    StoreType,
    RrsTemplateList,
    ChangeDefaultRrsTemplate,
    setRrsTemplateList,
    addModal,
} from "client/store"
import { hasAccess, hasProjectAccess, deepCopy } from "client/utils"
import {
    Link,
    CheckButton,
    DateFormatter,
    TableColumn,
} from "client/components"

const Columns = () => {
    const baseRoute = useSelector((state: StoreType) => state.rrsTemplate.baseRoute)
    const templateList = useSelector((state: StoreType) => state.rrsTemplate.templateList)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editAccess = !project.id
        ? hasAccess(PRM_RRS_TEMPLATE, EDIT)
        : hasProjectAccess(PRM_RRS_TEMPLATE, EDIT)

    const viewAccess = !project.id
        ? hasAccess(PRM_RRS_TEMPLATE, VIEW)
        : hasProjectAccess(PRM_RRS_TEMPLATE, VIEW)

    const deleteAccess = !project.id
        ? hasAccess(PRM_RRS_TEMPLATE, DELETE)
        : hasProjectAccess(PRM_RRS_TEMPLATE, DELETE)

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "100px",
            formatter: (template: RrsTemplate) => {
                if (!editAccess && !viewAccess) return template.name

                const href = `${baseRoute}/${editAccess ? EDIT : VIEW}/${template.id}`
                return (
                    <Link
                        href={href}
                        onClick={() => dispatch(addModal({ url: href }))}
                    >
                        {template.name}
                    </Link>
                )
            },
        },
        {
            field: "singleRiskMap",
            header: lang.singleRiskMap,
            sortable: true,
            cellMinWidth: "100px",
            formatter: (template: RrsTemplate) => (template.singleRiskMap ? lang.yes : lang.no),
        },
        {
            field: "riskMapGenerated",
            header: lang.riskMapGenerated,
            sortable: true,
            cellMinWidth: "100px",
            formatter: (template: RrsTemplate) => (template.riskMapGenerated ? lang.yes : lang.no),
        },
    ]

    if (!project.id) {
        columns.push({
            field: "default",
            header: lang.default,
            centerAlign: true,
            sortable: true,
            cellWidth: "100px",
            formatter: (template: RrsTemplate) => (
                <CheckButton
                    checked={template.default}
                    padding={false}
                    readOnly={!editAccess}
                    onChange={() => {
                        ChangeDefaultRrsTemplate(template).then((isDefault) => {
                            const templateListCopy: RrsTemplateList = deepCopy(templateList)
                            templateListCopy[template.id] = {
                                ...templateListCopy[template.id],
                                default: isDefault,
                            }
                            dispatch(setRrsTemplateList(templateListCopy))
                        })
                    }}
                />
            ),
        })
    }

    if (userData.accountId !== 1) {
        columns.push({
            field: "locked",
            header: lang.locked,
            sortable: true,
            cellWidth: "100px",
            cellMinWidth: "100px",
            formatter: (template: RrsTemplate) => (template.locked ? lang.yes : lang.no),
        })
    }

    columns.push({
        field: "createdAt",
        header: lang.created,
        sortable: true,
        formatter: (template: RrsTemplate) => <DateFormatter date={template.createdAt} />,
    })

    if (deleteAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
